<template>
  <div ref="snapContainer" class="featured-block-entry-point">
    <FeaturedRive />
  </div>
</template>

<script>
import FeaturedRive from './FeaturedRive.vue';

export default {
  components: { FeaturedRive },
  data() {
    return {
    };
  },
  
};
</script>

